import React, {useState} from "react";
import useStore from "../store";
import strings from "../lang/Localiz";
import HudTravelHint from "./HudTravelHint";


function HudBones() {
    const [hint, setHint] = useState(false);
    const cell = useStore(state => state.station);
    const action = useStore(state => state.action);

    const dismissPicker = () => {
        if (hint) setHint(false)
    }
    return (
        <div className={"travel-hud-move"}>
            {hint && !action &&
                <HudTravelHint dismissPicker={() => dismissPicker()}/>
            }
            
            {cell === 0 && !hint &&
                <div onClick={() => setHint(true)} className={"start-trial"}>
                    <span>{strings.bones.start.title}</span>
                </div>
            }
            <div className={"travel-hud-bones-panel"}>
                <div onClick={() => setHint(!hint)}
                     className={action ? "travel-hud-bones action-play" : "travel-hud-bones"}/>
            </div>
        </div>
    )
}

export default HudBones;
